"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveDocumentPage = void 0;
const verification_copy_1 = require("../../../../../constants/verification_copy");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const document_1 = require("../../../../../reducers/slices/document/document");
const doshx_controls_web_1 = require("doshx_controls_web");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const core_1 = require("@dnd-kit/core");
const react_router_dom_1 = require("react-router-dom");
const console_1 = require("../../../../../reducers/slices/console");
const preview_document_element_wrapper_1 = require("./preview_document_element_wrapper");
const constants_1 = require("../../../../../constants/constants");
const main_1 = require("../../../../../reducers/slices/main");
const get_document_elements_thunk_1 = require("../../../../../reducers/slices/document/thunks/get/get_document_elements_thunk");
const get_document_thunk_1 = require("../../../../../reducers/slices/document/thunks/get/get_document_thunk");
const sockets_1 = require("../../../../../helpers/sockets");
const certificate_1 = __importDefault(require("../certificate"));
const routes_1 = require("../../../../../constants/routes");
const scaleFunction_1 = require("../../../../../helpers/scaleFunction");
// ShimmerTitle removed - using custom loading skeleton instead
const useOnScreen_1 = require("../../../../../hooks/useOnScreen");
const update_document_image_thunk_1 = require("../../../../../reducers/slices/document/thunks/update/update_document_image_thunk");
const element_screenshot_1 = require("../../../../../helpers/element_screenshot");
const add_signature_1 = require("./add_signature");
const update_single_element_thunk_1 = require("../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
const update_user_thunk_1 = require("../../../../../reducers/slices/user/thunks/update_user_thunk");
const sign_document_thunk_1 = require("../../../../../reducers/slices/document/thunks/update/sign_document_thunk");
const complete_document_signing_1 = require("../../../../../api/calls/document/complete_document_signing");
const batch_save_elements_thunk_1 = require("../../../../../reducers/slices/document/thunks/batch_save_elements_thunk");
const mark_document_viewed_1 = require("../../../../../api/calls/document/mark_document_viewed");
const mark_signer_complete_1 = require("../../../../../api/calls/document/mark_signer_complete");
const create_sign_session_1 = require("../../../../../api/calls/facetec/create_sign_session");
const create_view_session_1 = require("../../../../../api/calls/facetec/create_view_session");
const document_overview_thunk_1 = require("../../../../../reducers/slices/document/thunks/document_overview_thunk");
const signed_user_documents_thunk_1 = require("../../../../../reducers/slices/document/thunks/signed_user_documents_thunk");
const get_documents_thunk_1 = require("../../../../../reducers/slices/document/thunks/get/get_documents_thunk");
const locationHelper_1 = require("../../../../../helpers/locationHelper");
const permissionHelper_1 = require("../../../../../helpers/permissionHelper");
const ui_1 = require("../../../../../reducers/slices/ui");
const testHelpers_1 = require("../../../../../helpers/testHelpers");
const facetecBypass_1 = require("../../../../../helpers/facetecBypass");
const sampleAppController_1 = require("../../../../../../facetec/src/sampleAppController");
const store_1 = require("../../../../../store");
const LiveDocumentPage = ({ document_id, type }) => {
    var _a, _b;
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const countRef = (0, react_1.useRef)(30);
    const { selectedDocumentElements, selectedDocument, isLoading, documentErrors, documentState, resizeMode } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user, token, accessAuth } = (0, react_redux_1.useSelector)((state) => state.userState);
    const { loginAuthenticated } = (0, react_redux_1.useSelector)((state) => state.uiState);
    const targetRef = (0, react_1.useRef)(null);
    const scrollableLiveDiv = (0, react_1.useRef)(null);
    const certificateRef = (0, react_1.useRef)(null);
    const [showComplete, setShowComplete] = (0, react_1.useState)(false);
    const [userDoneSigning, setUserDoneSigning] = (0, react_1.useState)(false);
    const [isPrint, setIsPrint] = (0, react_1.useState)(false);
    const [isCompleting, setIsCompleting] = (0, react_1.useState)(false);
    const [isMobileRedirecting, setIsMobileRedirecting] = (0, react_1.useState)(false);
    let scrollState = 0;
    // Check if current user has already completed their signing
    // Declared early so it can be used in useEffects below
    const currentUserSigner = (_a = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers) === null || _a === void 0 ? void 0 : _a.find((s) => s.email === user.email);
    const hasUserCompletedSigning = (currentUserSigner === null || currentUserSigner === void 0 ? void 0 : currentUserSigner.completedAt) ? true : false;
    // MOBILE BYPASS: Check if user is mobile (authenticated via Sky Lifestyle app)
    const isMobileUser = (accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.MOBILE;
    (0, react_1.useEffect)(() => {
        dispatch((0, document_1.setDocumentState)(type));
        let isMounted = true;
        let timeoutId;
        const tick = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!isMounted)
                return;
            if (countRef.current === 0) {
                countRef.current = 30;
                const file = yield (0, element_screenshot_1.takeElementScreenshot)(`document_1`);
                dispatch((0, update_document_image_thunk_1.update_document_image_thunk)({
                    data: {
                        _id: document_id,
                        payload: {
                            file,
                        },
                    },
                }));
            }
            else {
                countRef.current -= 1;
            }
            timeoutId = setTimeout(tick, 1000);
        });
        tick();
        return () => {
            isMounted = false;
            clearTimeout(timeoutId);
        };
    }, []);
    const getAccessDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        if (accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.redirect_url) {
            window.location.href = accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.redirect_url;
        }
    });
    const triggerMobileRedirect = () => {
        if (!(accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.redirect_url)) {
            return;
        }
        setIsMobileRedirecting(true);
        // Use top-level navigation so the Flutter WebView can intercept and cancel the redirect
        try {
            window.location.href = accessAuth.redirect_url;
            // Fallback: remove loader if nothing happens (e.g., desktop browser)
            setTimeout(() => setIsMobileRedirecting(false), 4000);
        }
        catch (error) {
            console.error("Failed to trigger mobile redirect:", error);
            setIsMobileRedirecting(false);
        }
    };
    (0, react_1.useEffect)(() => {
        if (selectedDocumentElements.length > 0) {
            if (selectedDocument.status !== "COMPLETED" && type === constants_1.TYPE_LINK) {
                const _validate = validate();
                setShowComplete(_validate);
            }
        }
    }, [selectedDocumentElements]);
    (0, react_1.useEffect)(() => {
        var _a;
        dispatch((0, console_1.setPageTitle)(`${(_a = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.name) !== null && _a !== void 0 ? _a : "Document"}`));
    }, [selectedDocument]);
    (0, react_1.useEffect)(() => {
        if (isPrint) {
            printDiv();
        }
    }, [isPrint]);
    (0, react_1.useEffect)(() => {
        if (document_id && token && type === constants_1.TYPE_LINK && (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "SENT") {
            // Only signers should mark document as viewed
            // Owners (non-signers) are just viewing, not signing
            if (!currentUserSigner) {
                return;
            }
            // Call backend to mark document as viewed
            // Backend will transition status SENT → VIEWED and update signer's viewedAt timestamp
            (0, mark_document_viewed_1.mark_document_viewed)({ document_id })
                .then((response) => {
                if (response.success) {
                    // Refresh document to show updated status
                    dispatch((0, get_document_elements_thunk_1.get_document_elements_thunk)({
                        data: {
                            document_id: document_id,
                        },
                    }));
                    // Refresh the documents list for the current status (for modal display)
                    if (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) {
                        dispatch((0, get_documents_thunk_1.get_documents_thunk)({ data: { status: selectedDocument.status } }));
                    }
                }
            })
                .catch((error) => {
                console.error("Failed to mark document as viewed:", error);
            });
        }
    }, [token, selectedDocument, currentUserSigner]);
    // Shared helper: resolve verification status + capture location before signing completion
    // Returns { verificationStatus, location } or null if cancelled/blocked
    const resolveSigningPrerequisites = () => __awaiter(void 0, void 0, void 0, function* () {
        // Determine verification status based on the current auth context.
        // "VERIFIED" must come from a real FaceTec-authenticated web or app session, not from test-mode bypasses.
        let verificationStatus = "NOT_VERIFIED";
        if (isTestMode) {
            verificationStatus = "NOT_VERIFIED";
        }
        else if (isMobileUser || (loginAuthenticated && !(0, facetecBypass_1.hasBypassPermission)())) {
            verificationStatus = "VERIFIED";
        }
        else if ((0, facetecBypass_1.hasBypassPermission)()) {
            const bypassChoice = yield new Promise((resolve) => {
                dispatch((0, main_1.setMessageModal)({
                    title: "Facial Recognition",
                    messages: [
                        "You have permission to bypass Facial Recognition.",
                        "You can verify with Facial Recognition for a 'Verified' certificate, or continue without it.",
                    ],
                    onClose: () => {
                        dispatch((0, main_1.setMessageModal)(null));
                        resolve("cancel");
                    },
                    buttons: [
                        {
                            label: verification_copy_1.FACIAL_RECOGNITION_VERIFY,
                            onClick: () => {
                                dispatch((0, main_1.setMessageModal)(null));
                                resolve("verify");
                            },
                        },
                        {
                            label: "Continue without verification",
                            onClick: () => {
                                dispatch((0, main_1.setMessageModal)(null));
                                resolve("bypass");
                            },
                        },
                    ],
                }));
            });
            if (bypassChoice === "cancel")
                return null;
            if (bypassChoice === "verify") {
                // Trigger FaceTec inline and wait for result
                const facetecDBRef = user === null || user === void 0 ? void 0 : user.facetecDBRef;
                if (!facetecDBRef) {
                    dispatch((0, main_1.setMessageModal)({
                        title: verification_copy_1.FACIAL_RECOGNITION_UNAVAILABLE,
                        messages: [verification_copy_1.FACIAL_RECOGNITION_NOT_ENROLLED, "Please use the bypass option instead."],
                    }));
                    return null;
                }
                // Reset auth state so we can detect fresh FaceTec completion
                dispatch((0, ui_1.resetFaceTecAuth)());
                dispatch((0, ui_1.clearFacetecError)());
                // Launch FaceTec and poll for loginAuthenticated state change
                const facetecSuccess = yield new Promise((resolve) => {
                    sampleAppController_1.SampleApp.onAuthenticateUserPressed(facetecDBRef);
                    let timeoutId;
                    const pollInterval = setInterval(() => {
                        const { uiState } = store_1.redux_store.getState();
                        if (uiState.facetecError) {
                            clearInterval(pollInterval);
                            clearTimeout(timeoutId);
                            resolve(false);
                        }
                        else if (uiState.loginAuthenticated) {
                            clearInterval(pollInterval);
                            clearTimeout(timeoutId);
                            resolve(true);
                        }
                    }, 500);
                    timeoutId = setTimeout(() => {
                        clearInterval(pollInterval);
                        resolve(false);
                    }, 120000);
                });
                if (facetecSuccess) {
                    verificationStatus = "VERIFIED";
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Verification Failed",
                        messages: [verification_copy_1.FACIAL_RECOGNITION_NOT_COMPLETED, "You can try again or use the bypass option."],
                    }));
                    return null;
                }
            }
            else {
                verificationStatus = "BYPASSED";
            }
        }
        else {
            const facetecChoice = yield new Promise((resolve) => {
                dispatch((0, main_1.setMessageModal)({
                    title: "Facial Recognition Required",
                    messages: [
                        "Facial Recognition is required to sign documents.",
                        "If you are not enrolled in Facial Recognition, you may continue and the document will be signed as 'Not Verified'.",
                    ],
                    onClose: () => {
                        dispatch((0, main_1.setMessageModal)(null));
                        resolve("cancel");
                    },
                    buttons: [
                        {
                            label: verification_copy_1.FACIAL_RECOGNITION_VERIFY,
                            onClick: () => {
                                dispatch((0, main_1.setMessageModal)(null));
                                resolve("retry");
                            },
                        },
                        {
                            label: "Continue as Not Verified",
                            onClick: () => {
                                dispatch((0, main_1.setMessageModal)(null));
                                resolve("continue");
                            },
                        },
                    ],
                }));
            });
            if (facetecChoice === "retry") {
                const facetecDBRef = user === null || user === void 0 ? void 0 : user.facetecDBRef;
                if (!facetecDBRef) {
                    // Not enrolled — can only continue as Not Verified
                    dispatch((0, main_1.setMessageModal)({
                        title: verification_copy_1.FACIAL_RECOGNITION_UNAVAILABLE,
                        messages: [verification_copy_1.FACIAL_RECOGNITION_NOT_ENROLLED, "The document will be signed as 'Not Verified'."],
                    }));
                    return null;
                }
                dispatch((0, ui_1.resetFaceTecAuth)());
                dispatch((0, ui_1.clearFacetecError)());
                const facetecSuccess = yield new Promise((resolve) => {
                    sampleAppController_1.SampleApp.onAuthenticateUserPressed(facetecDBRef);
                    const pollInterval = setInterval(() => {
                        const { uiState } = store_1.redux_store.getState();
                        if (uiState.facetecError) {
                            clearInterval(pollInterval);
                            resolve(false);
                        }
                        else if (uiState.loginAuthenticated) {
                            clearInterval(pollInterval);
                            resolve(true);
                        }
                    }, 500);
                    setTimeout(() => {
                        clearInterval(pollInterval);
                        resolve(false);
                    }, 120000);
                });
                if (facetecSuccess) {
                    verificationStatus = "VERIFIED";
                }
                else {
                    dispatch((0, main_1.setMessageModal)({
                        title: "Verification Failed",
                        messages: [verification_copy_1.FACIAL_RECOGNITION_NOT_COMPLETED, "The document will be signed as 'Not Verified'."],
                    }));
                    return null;
                }
            }
            else if (facetecChoice === "cancel") {
                return null;
            }
            else {
                verificationStatus = "NOT_VERIFIED";
            }
        }
        // Check location permission
        const locationPermissionCheck = isMobileUser ? { granted: true, status: "granted" } : yield (0, permissionHelper_1.checkLocationPermission)();
        if (!locationPermissionCheck.granted) {
            if (locationPermissionCheck.status === "denied") {
                dispatch((0, main_1.setMessageModal)({
                    title: "Location Permission Required",
                    messages: [
                        "Location permission was disabled or denied.",
                        "Location sharing is required to sign documents for legal compliance.",
                        "Please enable location access to continue.",
                    ],
                    buttons: [
                        {
                            label: "Enable Location",
                            onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                dispatch((0, main_1.setMessageModal)(null));
                                const retryResult = yield (0, permissionHelper_1.requestLocationPermission)();
                                dispatch((0, main_1.setMessageModal)({
                                    title: retryResult.granted ? "Permission Granted" : "Permission Denied",
                                    messages: [
                                        retryResult.granted
                                            ? "Location permission enabled. Please try signing again."
                                            : retryResult.error || "Please enable location in your browser settings to sign documents.",
                                    ],
                                }));
                            }),
                        },
                        {
                            label: "Cancel",
                            onClick: () => dispatch((0, main_1.setMessageModal)(null)),
                        },
                    ],
                }));
            }
            else {
                dispatch((0, main_1.setMessageModal)({
                    title: "Location Required",
                    messages: [locationPermissionCheck.error || "Location sharing is required to sign documents.", "Please enable location access and try again."],
                }));
            }
            return null;
        }
        // Capture location
        const location = yield (0, locationHelper_1.getUserLocation)();
        if (!location) {
            dispatch((0, main_1.setMessageModal)({
                title: "Location Required",
                messages: ["Location sharing is required to sign documents.", "Please enable location access and try again."],
            }));
            return null;
        }
        return { verificationStatus, location };
    });
    const createVerifiedSigningSession = (docId) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const viewSessionResponse = yield (0, create_view_session_1.create_view_session)();
        if (!viewSessionResponse.success) {
            dispatch((0, main_1.setMessageModal)({
                title: "Verification Session Failed",
                messages: [viewSessionResponse.message || "Failed to establish a Facial Recognition session."],
            }));
            return null;
        }
        const editSessionResponse = yield (0, create_sign_session_1.create_sign_session)({ document_id: docId });
        if (!editSessionResponse.success || !((_c = editSessionResponse.session) === null || _c === void 0 ? void 0 : _c.token)) {
            dispatch((0, main_1.setMessageModal)({
                title: "Verification Session Failed",
                messages: [editSessionResponse.message || "Failed to establish a Facial Recognition signing session."],
            }));
            return null;
        }
        return editSessionResponse.session.token;
    });
    // Single signing completion function for both "Complete" (all signers) and "Done" (my part)
    // mode: "complete" = all signers done, "done" = just this signer
    const submitSignerCompletion = (mode) => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        if (isCompleting)
            return;
        setIsCompleting(true);
        try {
            if (mode === "complete") {
                yield dispatch((0, batch_save_elements_thunk_1.batch_save_elements_thunk)()).unwrap();
            }
            const prerequisites = yield resolveSigningPrerequisites();
            if (!prerequisites) {
                setIsCompleting(false);
                return;
            }
            const { verificationStatus, location } = prerequisites;
            // Call the appropriate backend endpoint
            const docId = mode === "complete" ? document_id : selectedDocument._id;
            const verifiedSessionToken = verificationStatus === "VERIFIED" ? yield createVerifiedSigningSession(docId) : null;
            if (verificationStatus === "VERIFIED" && !verifiedSessionToken) {
                return;
            }
            let success = false;
            let errorMessage = "";
            let allComplete = mode === "complete";
            if (mode === "complete") {
                const response = yield (0, complete_document_signing_1.complete_document_signing)({
                    document_id: docId,
                    location,
                    facetec_verified: verificationStatus === "VERIFIED",
                    facetec_session_id: verifiedSessionToken || undefined,
                    facetec_session_token: verifiedSessionToken || undefined,
                    verification_status: verificationStatus,
                });
                success = response.success;
                errorMessage = response.message || "Failed to complete document.";
            }
            else {
                const response = yield (0, mark_signer_complete_1.mark_signer_complete)({
                    document_id: docId,
                    location: {
                        latitude: location.latitude,
                        longitude: location.longitude,
                        location_name: location.location_name,
                    },
                    facetec_verified: verificationStatus === "VERIFIED",
                    facetec_session_id: verifiedSessionToken || undefined,
                    facetec_session_token: verifiedSessionToken || undefined,
                    verification_status: verificationStatus,
                });
                success = response.success;
                errorMessage = response.message || "Failed to mark completion.";
                allComplete = ((_d = response.content) === null || _d === void 0 ? void 0 : _d.all_complete) === true;
            }
            if (!success) {
                dispatch((0, main_1.setMessageModal)({ title: "Error", messages: [errorMessage] }));
                return;
            }
            // Refresh document data
            if (mode === "complete") {
                yield dispatch((0, get_document_thunk_1.get_document_thunk)({ data: { _id: docId } }));
            }
            else {
                dispatch((0, get_document_elements_thunk_1.get_document_elements_thunk)({ data: { document_id: docId } }));
            }
            // Mobile redirect
            if ((accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.MOBILE && (accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.redirect_url)) {
                if (mode === "done") {
                    triggerMobileRedirect();
                }
                else {
                    window.location.href = accessAuth.redirect_url;
                }
                return;
            }
            // Refresh lists
            dispatch((0, document_overview_thunk_1.document_overview_thunk)());
            dispatch((0, signed_user_documents_thunk_1.signed_user_documents_thunk)({ email: user.email }));
            if (mode === "done") {
                dispatch((0, get_documents_thunk_1.get_documents_thunk)({ data: { status: selectedDocument.status } }));
            }
            // Success message based on verification status
            const successTitle = verificationStatus === "VERIFIED"
                ? "Success! Verified"
                : verificationStatus === "BYPASSED"
                    ? "Success! Verification Bypassed"
                    : "Success! Document Signed";
            const successDetail = mode === "complete" ? "All signers will receive a completion notification email." : "Other signers can now proceed.";
            const certificateMessage = mode === "complete" || allComplete
                ? "The document certificate is now available."
                : "The certificate will be available once all signers have completed the document.";
            dispatch((0, main_1.setMessageModal)({
                title: successTitle,
                messages: [successDetail, certificateMessage],
            }));
            setTimeout(() => navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DASHBOARD_ROUTE}`), mode === "complete" ? 3000 : 2000);
        }
        catch (error) {
            console.error(`Failed to ${mode} document:`, error);
            dispatch((0, main_1.setMessageModal)({
                title: "Error",
                messages: ["Failed to complete signing. Please try again."],
            }));
        }
        finally {
            setIsCompleting(false);
        }
    });
    const completeDocument = () => submitSignerCompletion("complete");
    // const validate = () => {
    //   const errors = [];
    //   let fillables = selectedDocumentElements.filter((x) => x.extra_attributes?.edit_type === "fillable");
    //   let myFillables = fillables;
    //   if (selectedDocument.signers.length > 0) {
    //     myFillables = fillables.filter((x) => x.extra_attributes?.user?.email === user.email);
    //   }
    //   myFillables = myFillables.filter((x) => x.extra_attributes?.value === "");
    //   for (const fillable of fillables) {
    //     if (!fillable.extra_attributes?.value || fillable.extra_attributes?.value === "") {
    //       errors.push(fillable._id);
    //     }
    //   }
    //   if (errors.length > 0) {
    //     dispatch(setDocumentErrors(errors));
    //     if (myFillables.length === 0) {
    //       setUserDoneSigning(true);
    //     } else {
    //       setUserDoneSigning(false);
    //     }
    //     return false;
    //   } else {
    //     dispatch(setDocumentErrors([]));
    //   }
    //   return true;
    // };
    const validate = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const errors = [];
        const myErrors = [];
        let fillables = selectedDocumentElements.filter((x) => { var _a; return ((_a = x.extra_attributes) === null || _a === void 0 ? void 0 : _a.edit_type) === "fillable"; });
        let myFillables = fillables;
        if (selectedDocument.signers.length > 0) {
            myFillables = fillables.filter((x) => { var _a, _b; return ((_b = (_a = x.extra_attributes) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.email) === user.email; });
        }
        // Check ALL fillables for error highlighting (visual feedback)
        for (const fillable of fillables) {
            let isFilled = false;
            switch (fillable.type) {
                case "Signature":
                case "Initials":
                case "TextField":
                    isFilled = !!((_a = fillable.extra_attributes) === null || _a === void 0 ? void 0 : _a.value);
                    break;
                case "Checkbox":
                    isFilled = !!((_b = fillable.extra_attributes) === null || _b === void 0 ? void 0 : _b.checked);
                    break;
                case "Radio Buttons":
                    isFilled = !!((_c = fillable.extra_attributes) === null || _c === void 0 ? void 0 : _c.selectedValue);
                    break;
                case "Date":
                    isFilled = !!((_d = fillable.extra_attributes) === null || _d === void 0 ? void 0 : _d.value);
                    break;
                default:
                    isFilled = !!((_e = fillable.extra_attributes) === null || _e === void 0 ? void 0 : _e.value);
            }
            if (!isFilled) {
                errors.push(fillable._id);
            }
        }
        // Check ONLY MY fillables for completion validation
        for (const myFillable of myFillables) {
            let isFilled = false;
            switch (myFillable.type) {
                case "Signature":
                case "Initials":
                case "TextField":
                    isFilled = !!((_f = myFillable.extra_attributes) === null || _f === void 0 ? void 0 : _f.value);
                    break;
                case "Checkbox":
                    isFilled = !!((_g = myFillable.extra_attributes) === null || _g === void 0 ? void 0 : _g.checked);
                    break;
                case "Radio Buttons":
                    isFilled = !!((_h = myFillable.extra_attributes) === null || _h === void 0 ? void 0 : _h.selectedValue);
                    break;
                case "Date":
                    isFilled = !!((_j = myFillable.extra_attributes) === null || _j === void 0 ? void 0 : _j.value);
                    break;
                default:
                    isFilled = !!((_k = myFillable.extra_attributes) === null || _k === void 0 ? void 0 : _k.value);
            }
            if (!isFilled) {
                myErrors.push(myFillable._id);
            }
        }
        // Dispatch ALL errors for visual highlighting
        dispatch((0, document_1.setDocumentErrors)(errors));
        // But only validate MY fields for completion
        if (myErrors.length > 0) {
            // I still have fields to complete
            setUserDoneSigning(false);
            return false;
        }
        else {
            // I've completed all my fields
            // Show "Done" button only if there are OTHER users' errors (I'm done but document isn't)
            // Show "Complete" button if ALL fields are done (entire document complete)
            const hasOtherUsersErrors = errors.length > 0;
            setUserDoneSigning(hasOtherUsersErrors);
            return !hasOtherUsersErrors; // Complete button shows when no errors at all
        }
    };
    const printDiv = () => {
        document.title = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.name;
        var printContents = targetRef.current.innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.title = "Skysign";
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    // useEffect(() => {
    //   if (scrollableLiveDiv.current) {
    //     const documentLength = scrollableLiveDiv.current?.scrollHeight;
    //     scrollState = documentLength / selectedDocument?.pages;
    //     // dispatch(setScrollTop(scrollState));
    //     // scrollableLiveDiv.current.addEventListener("scroll", scrollHandler);
    //     // return () => {
    //     //   scrollableLiveDiv.current?.removeEventListener("scroll", scrollHandler);
    //     // };
    //   }
    // }, [selectedDocument]);
    // const scrollHandler = (e: any) => {
    //   if (selectedDocument?.pages) {
    //     const documentLength = e.target.scrollHeight;
    //     const pageLength = documentLength / selectedDocument?.pages;
    //     const _scrollTop = e.target.scrollTop;
    //     if (_scrollTop >= scrollState + 1) {
    //       scrollState = scrollState + pageLength;
    //       dispatch(setScrollTop(scrollState));
    //     }
    //   }
    // };
    const fillableSignatureElements = selectedDocumentElements.filter((el) => {
        var _a, _b, _c, _d, _e, _f;
        return el.type === "Signature" &&
            ((_a = el.extra_attributes) === null || _a === void 0 ? void 0 : _a.edit_type) === "fillable" &&
            (!((_c = (_b = el.extra_attributes) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.email) || ((_e = (_d = el.extra_attributes) === null || _d === void 0 ? void 0 : _d.user) === null || _e === void 0 ? void 0 : _e.email) === user.email) &&
            !((_f = el.extra_attributes) === null || _f === void 0 ? void 0 : _f.value);
    });
    const fillableInitialsElements = selectedDocumentElements.filter((el) => {
        var _a, _b, _c, _d, _e, _f;
        return el.type === "Initials" &&
            ((_a = el.extra_attributes) === null || _a === void 0 ? void 0 : _a.edit_type) === "fillable" &&
            (!((_c = (_b = el.extra_attributes) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.email) || ((_e = (_d = el.extra_attributes) === null || _d === void 0 ? void 0 : _d.user) === null || _e === void 0 ? void 0 : _e.email) === user.email) &&
            !((_f = el.extra_attributes) === null || _f === void 0 ? void 0 : _f.value);
    });
    // Check if there are any signature/initials fields (for resize/move toggle visibility)
    const hasSignatureOrInitialsFields = selectedDocumentElements.some((el) => { var _a; return (el.type === "Signature" || el.type === "Initials") && ((_a = el.extra_attributes) === null || _a === void 0 ? void 0 : _a.edit_type) === "fillable"; });
    // DnD sensors for drag-to-move signed fields
    // Use distance-based activation to avoid blocking taps/clicks
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.MouseSensor, {
        activationConstraint: { distance: 10 },
    }), (0, core_1.useSensor)(core_1.TouchSensor, {
        activationConstraint: { distance: 10 },
    }));
    // const handleBulkSignSignatures = () => {
    //   dispatch(
    //     setContentModal({
    //       title: "Sign All Signature Fields",
    //       content: (
    //         <AddSignature
    //           value={user.signature}
    //           type="Signature"
    //           onClick={(signature) => {
    //             fillableSignatureElements.forEach((el) => {
    //               dispatch(
    //                 update_single_element_thunk({
    //                   data: {
    //                     document_id: selectedDocument._id,
    //                     payload: {
    //                       ...el,
    //                       extra_attributes: {
    //                         ...el.extra_attributes,
    //                         value: signature,
    //                       },
    //                     },
    //                   },
    //                 }),
    //               );
    //             });
    //           }}
    //         />
    //       ),
    //     }),
    //   );
    // };
    // Check if test mode is enabled (for FaceTec bypass)
    const isTestMode = (0, testHelpers_1.isTestModeEnabled)();
    const handleBulkSignSignatures = () => {
        // FaceTec verification flow:
        // - Mobile users: Already authenticated via Sky Lifestyle app, proceed
        // - Test mode: Show bypass notice, proceed with signing (marked as bypassed in certificate)
        // - Not authenticated: Trigger FaceTec auth, if cancelled user can try again
        if (!loginAuthenticated && !isMobileUser) {
            if (isTestMode) {
                // Test mode: Show notice but allow signing to proceed
                dispatch((0, main_1.setMessageModal)({
                    title: verification_copy_1.TEST_MODE_BYPASS_TITLE,
                    messages: [...verification_copy_1.TEST_MODE_BYPASS_MESSAGES, "This signing will be marked as 'Test Mode Bypass' in the certificate."],
                }));
                // Don't return - allow signing to proceed after dismissing modal
            }
            else {
                // Production: Trigger FaceTec auth - if cancelled, user can try again
                dispatch((0, ui_1.showQrAuth)());
                return;
            }
        }
        dispatch((0, main_1.setContentModal)({
            title: "Sign All Signature Fields",
            content: (react_1.default.createElement(add_signature_1.AddSignature, { value: user.signature, type: "Signature", onClick: (signature) => __awaiter(void 0, void 0, void 0, function* () {
                    // Update all signature fields
                    yield Promise.all(fillableSignatureElements.map((el) => dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                        data: {
                            document_id: selectedDocument._id,
                            payload: Object.assign(Object.assign({}, el), { extra_attributes: Object.assign(Object.assign({}, el.extra_attributes), { value: signature }) }),
                        },
                    }))));
                    // Now mark the signer as signed
                    yield dispatch((0, sign_document_thunk_1.sign_document_thunk)({ document_id: selectedDocument._id }));
                }) })),
        }));
    };
    const handleBulkSignInitials = () => {
        // FaceTec verification flow:
        // - Mobile users: Already authenticated via Sky Lifestyle app, proceed
        // - Test mode: Show bypass notice, proceed with signing (marked as bypassed in certificate)
        // - Not authenticated: Trigger FaceTec auth, if cancelled user can try again
        if (!loginAuthenticated && !isMobileUser) {
            if (isTestMode) {
                // Test mode: Show notice but allow signing to proceed
                dispatch((0, main_1.setMessageModal)({
                    title: verification_copy_1.TEST_MODE_BYPASS_TITLE,
                    messages: [...verification_copy_1.TEST_MODE_BYPASS_MESSAGES, "This signing will be marked as 'Test Mode Bypass' in the certificate."],
                }));
                // Don't return - allow signing to proceed after dismissing modal
            }
            else {
                // Production: Trigger FaceTec auth - if cancelled, user can try again
                dispatch((0, ui_1.showQrAuth)());
                return;
            }
        }
        dispatch((0, main_1.setContentModal)({
            title: "Sign All Initial Fields",
            content: (react_1.default.createElement(add_signature_1.AddSignature, { value: user.initials, type: "Initials", onClick: (initials) => __awaiter(void 0, void 0, void 0, function* () {
                    // Save initials to Redux state for reuse
                    dispatch((0, document_1.setInitials)(initials));
                    // Save initials to user profile for persistence
                    dispatch((0, update_user_thunk_1.update_user_thunk)({ data: { initials } }));
                    // Save initials to all fillable elements
                    yield Promise.all(fillableInitialsElements.map((el) => dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                        data: {
                            document_id: selectedDocument._id,
                            payload: Object.assign(Object.assign({}, el), { extra_attributes: Object.assign(Object.assign({}, el.extra_attributes), { value: initials }) }),
                        },
                    }))));
                }) })),
        }));
    };
    const handleDoneClick = () => __awaiter(void 0, void 0, void 0, function* () {
        // Non-signers (owners viewing) just redirect to dashboard
        if (!currentUserSigner) {
            dispatch((0, main_1.setMessageModal)({
                title: "Document Viewed",
                messages: ["You have finished viewing this document. The assigned signers will complete their signatures."],
            }));
            setTimeout(() => navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.DASHBOARD_ROUTE}`), 1500);
            return;
        }
        // Signers use the same completion flow as "Complete"
        submitSignerCompletion("done");
    });
    return (react_1.default.createElement("div", { className: "w-full h-full m-auto overflow-x-auto px-2 sm:px-4", style: { fontSize: `${(0, scaleFunction_1.scaleFunction)(14)}px` } },
        isMobileRedirecting && (react_1.default.createElement("div", { className: "fixed inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-90" },
            react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "large", progressColor: "text-primary" }),
            react_1.default.createElement("p", { className: "mt-4 text-gray-700 text-center" }, "Redirecting..."))),
        react_1.default.createElement("div", { ref: scrollableLiveDiv, id: "scrollableLiveDiv", className: "flex flex-col gap-2 sm:gap-4 w-full h-full overflow-y-auto overflow-x-auto pb-16" },
            react_1.default.createElement("div", { className: "sticky top-2 sm:top-8 z-30 pr-2 sm:pr-6 pb-2 sm:pb-4" },
                react_1.default.createElement("div", { className: "flex flex-row flex-wrap justify-between items-center gap-2 mb-2 sm:mb-4" },
                    react_1.default.createElement("div", { className: "flex flex-row" }, documentState !== constants_1.TYPE_LINK && history.length > 1 && (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { iconColor: "text-black", label: "Back", size: "xsmall", startIcon: pro_light_svg_icons_1.faChevronLeft, backgroundColor: "bg-transparent", textColor: "text-black", onClick: () => {
                            navigate(-1);
                        } }))),
                    react_1.default.createElement("div", { className: "flex flex-row gap-1 sm:gap-2 items-center justify-end" },
                        false &&
                            documentState !== constants_1.TYPE_PREVIEW &&
                            (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "COMPLETED" &&
                            documentState == constants_1.TYPE_LINK &&
                            hasSignatureOrInitialsFields &&
                            !hasUserCompletedSigning && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "md:hidden", title: resizeMode ? "Resize: On" : "Resize: Off" },
                                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faExpandArrows, size: "small", backgroundColor: resizeMode ? "bg-secondary" : "bg-gray-200", iconColor: resizeMode ? "text-white" : "text-gray-600", onClick: () => {
                                        dispatch((0, document_1.toggleResizeMode)());
                                    } })),
                            react_1.default.createElement("div", { className: "hidden md:block" },
                                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { startIcon: pro_light_svg_icons_1.faExpandArrows, iconColor: resizeMode ? "text-white" : "text-gray-600", label: resizeMode ? "Resize: On" : "Resize: Off", size: "small", backgroundColor: resizeMode ? "bg-secondary" : "bg-gray-200", textColor: resizeMode ? "text-white" : "text-gray-600", onClick: () => {
                                        dispatch((0, document_1.toggleResizeMode)());
                                    } })))),
                        documentState !== constants_1.TYPE_PREVIEW && (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "COMPLETED" && fillableSignatureElements.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "md:hidden", title: "Sign All Signatures" },
                                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faSignature, size: "small", backgroundColor: "bg-secondary", iconColor: "text-white", onClick: handleBulkSignSignatures })),
                            react_1.default.createElement("div", { className: "hidden md:block" },
                                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Sign All Signatures", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: handleBulkSignSignatures })))),
                        documentState !== constants_1.TYPE_PREVIEW && (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "COMPLETED" && fillableInitialsElements.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "md:hidden", title: "Sign All Initials" },
                                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faPenNib, size: "small", backgroundColor: "bg-secondary", iconColor: "text-white", onClick: handleBulkSignInitials })),
                            react_1.default.createElement("div", { className: "hidden md:block" },
                                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Sign All Initials", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: handleBulkSignInitials })))),
                        documentState == constants_1.TYPE_LINK &&
                            ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "COMPLETED" && (!accessAuth || (accessAuth && (accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.WEBSITE)) ? (react_1.default.createElement("a", { href: `${process.env.API_URL}/download/pdf?document_id=${selectedDocument._id}`, target: "_blank", rel: "noopener noreferrer" },
                                react_1.default.createElement("div", { className: "md:hidden", title: "Download PDF" },
                                    react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { onClick: () => { }, icon: pro_light_svg_icons_1.faDownload, size: "small", backgroundColor: "bg-secondary", iconColor: "text-white" })),
                                react_1.default.createElement("div", { className: "hidden md:block" },
                                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { onClick: () => { }, label: "Download PDF", size: "small", backgroundColor: "bg-secondary", textColor: "text-white" })))) : (react_1.default.createElement(react_1.default.Fragment, null))),
                        showComplete && (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "COMPLETED" && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "md:hidden", title: isCompleting ? "Completing..." : "Complete" },
                                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { onClick: () => {
                                        completeDocument();
                                    }, icon: pro_light_svg_icons_1.faCheck, size: "small", backgroundColor: isCompleting ? "bg-gray-400" : "bg-secondary", iconColor: "text-white" })),
                            react_1.default.createElement("div", { className: "hidden md:block" },
                                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { onClick: () => {
                                        completeDocument();
                                    }, label: isCompleting ? "Completing..." : "Complete", size: "small", backgroundColor: isCompleting ? "bg-gray-400" : "bg-secondary", textColor: "text-white" })))),
                        userDoneSigning && (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) !== "COMPLETED" && documentErrors.length > 0 && !hasUserCompletedSigning && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", { className: "md:hidden", title: "Done" },
                                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faCheck, size: "small", backgroundColor: "bg-secondary", iconColor: "text-white", onClick: handleDoneClick })),
                            react_1.default.createElement("div", { className: "hidden md:block" },
                                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Done", size: "small", backgroundColor: "bg-secondary", textColor: "text-white", onClick: handleDoneClick }))))))),
            react_1.default.createElement(core_1.DndContext, { sensors: sensors },
                react_1.default.createElement("div", { ref: targetRef, className: "flex flex-col gap-6 m-auto pb-8" },
                    [...Array((_b = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.pages) !== null && _b !== void 0 ? _b : 0).keys()].map((x) => (react_1.default.createElement("div", { className: "", id: `page_${x + 1}`, key: x },
                        react_1.default.createElement(DocumentPages, { index: x + 1, isPrint: isPrint }),
                        react_1.default.createElement("small", { className: isPrint ? "ml-24 mt-16 text-gray-500" : "", style: { fontSize: "12px", minWidth: "max-content" } },
                            "page ",
                            x + 1,
                            " of ", selectedDocument === null || selectedDocument === void 0 ? void 0 :
                            selectedDocument.pages),
                        x + 1 !== (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.pages) && react_1.default.createElement("div", { className: "pagebreak" })))),
                    (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.status) === "COMPLETED" && (react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "pagebreak" }),
                        react_1.default.createElement("div", { ref: certificateRef },
                            react_1.default.createElement(certificate_1.default, { isPrint: isPrint })))))))));
};
exports.LiveDocumentPage = LiveDocumentPage;
function DocumentPages({ index, isPrint }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocumentElements, selectedDocument, isLoading, scrollTop } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user, token } = (0, react_redux_1.useSelector)((state) => state.userState);
    const pageRef = (0, react_1.useRef)(null);
    const isVisible = (0, useOnScreen_1.useOnScreen)(pageRef);
    // Get document dimensions (from PDF or defaults)
    const docDimensions = (0, scaleFunction_1.getDocumentDimensions)(selectedDocument);
    const getDocumentElements = (loader = true) => {
        dispatch((0, get_document_elements_thunk_1.get_document_elements_thunk)({
            data: {
                document_id: selectedDocument._id,
                page: String(index),
            },
            loader: loader,
        }));
    };
    (0, react_1.useEffect)(() => {
        if (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id) {
            const pageElement = selectedDocumentElements.filter((x) => x.page == index);
            if (pageElement.length === 0 && isVisible) {
                getDocumentElements();
            }
        }
    }, [selectedDocument, isVisible]);
    // useEffect(() => {
    //   if (selectedDocument?._id && selectedDocument?.status !== "COMPLETED") {
    //     const scrollableDiv = document.getElementById("scrollableLiveDiv");
    //     if (scrollableDiv) {
    //       const pageHeight = scrollableDiv.scrollHeight / selectedDocument.pages;
    //       const pageElement = selectedDocumentElements.filter((x) => x.page == index);
    //       if (pageHeight * index === scrollTop) {
    //         getDocumentElements();
    //       } else if (pageHeight * index < scrollTop) {
    //         if (pageElement.length === 0) {
    //           getDocumentElements();
    //         }
    //       }
    //     }
    //   }
    // }, [scrollTop, selectedDocument]);
    (0, react_1.useEffect)(() => {
        if (selectedDocument) {
            const socketData = [
                {
                    url: process.env.API_URL,
                    eventName: `document_element_update_${index}_${selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id}`,
                    callback: (data) => {
                        if ((data === null || data === void 0 ? void 0 : data.last_updated_by) !== user._id) {
                            getDocumentElements(false);
                        }
                    },
                },
            ];
            const socketService = new sockets_1.SocketService(socketData, token);
            socketService.startListening();
            return () => {
                setTimeout(() => {
                    socketService.stopListening();
                    socketService.close();
                }, 500);
            };
        }
    }, [selectedDocument]);
    return (react_1.default.createElement("div", { ref: pageRef, style: {
            // Use document dimensions (from PDF or defaults) to match draft mode positioning context
            // This ensures absolute-positioned fields appear at correct coordinates
            width: `${(0, scaleFunction_1.scaleFunction)(docDimensions.width, docDimensions.width)}px`,
            height: `${(0, scaleFunction_1.scaleFunction)(docDimensions.height, docDimensions.width)}px`,
            minHeight: `${(0, scaleFunction_1.scaleFunction)(docDimensions.height, docDimensions.width)}px`,
            fontSize: `${(0, scaleFunction_1.scaleFunction)(14, docDimensions.width)}px`,
        }, className: `bg-white m-auto ${isPrint ? "" : "shadow-md"} flex flex-col flex-grow item-center justify-start flex-1 relative p-1` }, selectedDocumentElements && selectedDocumentElements.length > 0 ? ((() => {
        const pageElements = selectedDocumentElements.filter((elem) => (elem === null || elem === void 0 ? void 0 : elem.page) === index);
        // Separate page backgrounds (PDF images) from other elements
        const isPageBackground = (el) => {
            var _a;
            const text = ((_a = el === null || el === void 0 ? void 0 : el.extra_attributes) === null || _a === void 0 ? void 0 : _a.text) || "";
            return (el.type === "Text" &&
                (text.trim().startsWith("<img") ||
                    (text.trim().startsWith("<p>") &&
                        text.includes("<img") &&
                        !text
                            .replace(/<img[^>]*>/g, "")
                            .replace(/<\/?p>/g, "")
                            .trim())));
        };
        const backgrounds = pageElements.filter(isPageBackground);
        const fields = pageElements.filter((el) => !isPageBackground(el));
        // Render backgrounds first (behind), then fields on top
        return [
            ...backgrounds.map((element) => react_1.default.createElement(preview_document_element_wrapper_1.PreviewDocumentElementWrapper, { key: element._id, element: element })),
            ...fields
                .sort((a, b) => { var _a, _b; return (((_a = a.extra_attributes) === null || _a === void 0 ? void 0 : _a.y) || 0) - (((_b = b.extra_attributes) === null || _b === void 0 ? void 0 : _b.y) || 0); })
                .map((element) => react_1.default.createElement(preview_document_element_wrapper_1.PreviewDocumentElementWrapper, { key: element._id, element: element })),
        ];
    })()) : (react_1.default.createElement("div", { className: "space-y-3 animate-pulse" },
        react_1.default.createElement("div", { className: "h-4 bg-gray-200 rounded w-3/4" }),
        react_1.default.createElement("div", { className: "h-4 bg-gray-200 rounded w-1/2" })))));
}
exports.default = DocumentPages;
